import { render } from "./lightMap.vue?vue&type=template&id=c0b79a26"
import script from "./lightMap.vue?vue&type=script&lang=js"
export * from "./lightMap.vue?vue&type=script&lang=js"

import "./lightMap.vue?vue&type=style&index=0&id=c0b79a26&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__